import { Directive, HostBinding, Input } from '@angular/core';

export type ButtonSizes = 'small' | 'medium' | 'normal' | 'large' | 'full';

@Directive({
  selector: '[xButtonSize]',
})
export class ButtonSizeDirective {
  @HostBinding('class')
  class = 'size-medium';

  @Input()
  set xButtonSize(size: ButtonSizes) {
    this.class = `size-${size}`;
  }
}
